import React from "react";

const TooltipDetail = ({ label, value }) => {
  if (!value) return null;
  return (
    <div className="flex items-start gap-2">
      <span className="font-medium text-gray-500 min-w-[100px]">{label}:</span>
      <span className="flex-1 text-gray-800">{value}</span>
    </div>
  );
};

const AppointmentTooltip = ({ tooltip }) => {
  if (!tooltip?.visible || !tooltip?.event) return null;
  const { event } = tooltip;
  const extendedProps = event.extendedProps ?? {};

  const stops = Array.isArray(extendedProps.shipmentStops)
  ? extendedProps.shipmentStops
  : [];

  return (
    <div
      className="fixed z-[100] pointer-events-none"
      style={{
        left: `${tooltip.x}px`,
        top: `${tooltip.y}px`,
        transform: "translate(-50%, -100%)",
        marginTop: "-8px" 
      }}
    >
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3 min-w-[240px] max-w-[320px] relative">
        
        {/* CSS Triangle Arrow */}
        <div className="absolute left-1/2 -bottom-[8px] transform -translate-x-1/2 flex flex-col items-center">
           <div className="w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent border-t-gray-200 absolute mt-[1px]" />
           <div className="w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent border-t-white absolute" />
        </div>

        <div className="space-y-2.5">
          <h4 className="font-semibold text-[#1e2a74] text-sm border-b border-gray-100 pb-1.5">
            Appointment Details
          </h4>

          <div className="space-y-1.5 text-xs text-gray-700 pb-1">
            <TooltipDetail label="Order #" value={extendedProps.orderNumber?.replace(/,/g, ", ")} />
          </div>

          {stops.length > 0 && (
            <div className="border-t border-gray-100 pt-2">
              <p className="text-xs font-semibold text-[#1e2a74] mb-1.5">Stops</p>
              
              <div className="flex flex-col">
                {stops.map((stop, i) => {
                  if (!stop) return null;
                  const number = stop.stopNumber || i + 1;
                  const isPickup = stop.stopType === "PICKUP";
                  const location = [stop.stopName, stop.city, stop.state]
                    .filter(Boolean)
                    .join(", ");
                  
                  const apptTime = stop.appointmentStart
                    ? new Date(stop.appointmentStart).toLocaleString("en-US", {
                        month: "2-digit", day: "2-digit",
                        hour: "2-digit", minute: "2-digit", hour12: true,
                      })
                    : null;
                  
                  const salesOrderNumbers = stop.salesOrderNumbers ? stop.salesOrderNumbers : null;
                  
                  const gateOut = stop.actualGateOut
                    ? new Date(stop.actualGateOut).toLocaleString("en-US", {
                        month: "2-digit", day: "2-digit",
                        hour: "2-digit", minute: "2-digit", hour12: true,
                      })
                    : null;

                  return (
                    <div
                      key={i}
                      className="text-xs py-2 border-b border-gray-100 last:border-0 last:pb-0 first:pt-0"
                    >
                      {/* Top Row: Number, Location, and Stop Type */}
                      <div className="flex items-center gap-1.5 flex-wrap mb-1.5">
                        <span className="font-semibold text-gray-400">{number}.</span>
                        
                        {location ? (
                          <span className="text-gray-800 font-semibold">{location}</span>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                        
                        {/* Demoted Stop Type Indicator */}
                        <span className="text-[10px] font-medium text-gray-400 uppercase tracking-wide ml-1">
                          • {isPickup ? "Pickup" : "Drop-off"}
                        </span>
                      </div>
                      
                      {/* Indented Metadata Row */}
                      <div className="pl-5 space-y-0.5">
                        {apptTime && (
                          <p className="text-gray-500">
                            Time: <span className="text-gray-800 ml-1">{apptTime}</span>
                          </p>
                        )}
                        {salesOrderNumbers && (
                          <p className="text-gray-500">
                            Order #: <span className="text-gray-800 ml-1">{salesOrderNumbers}</span>
                          </p>
                        )}
                        {gateOut && (
                          <p className="text-gray-500">
                            Gate-out: <span className="text-gray-800 ml-1">{gateOut}</span>
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentTooltip;